"use strict";
import ReactDOM from "react-dom";
import $ from "jquery";
import App from "./accounts_payable/app";
import Account from "./api/account";
import Auth from "./util/auth";
import ResetPasswordPage from "./accounts_payable/reset_password/reset_password_page";
import ConfirmAndSubmitPage from "./accounts_payable/confirm_and_submit_page";
import DocumentIndexerPage from "./accounts_payable/document_indexer_page";
import FlowModeFindNextItemPage from "./accounts_payable/flow_mode/flow_mode_find_next_item_page";
import EmailPage from "./accounts_payable/email_page";
import FactorInvoiceExtractDataPage from "./accounts_payable/factor_invoice_extract_data_page";
import Hotkeys from "./util/hotkeys";
import LoginForm from "./accounts_payable/login_form";
import Logout from "./accounts_payable/logout";
import presenceService from "./accounts_payable/presence_service_next_gen";
import ReplyView from "./accounts_payable/reply_view";
import AnalyticsPage from "./accounts_payable/analytics_page";
import RootPage from "./accounts_payable/root_page";
import { createHistory, useBasename, useQueries } from "history";
import { Router, Route, IndexRoute, Redirect } from "react-router";
import { Provider } from "react-redux";
import configureStore from "./accounts_payable/redux/configure_store";
import PineRoute from "./util/pine/pine_route";
import React from "react";
import { readOnlyRedirect } from "./accounts_payable/read_only";
import { factorInvoiceWorkflowWithEmail } from "./accounts_payable/flow_mode/dashboard_paths";
global.__DEV__ = process.env.NODE_ENV === "development";
if (__DEV__) {
  window.React = React;
}
$.ajaxSetup({
  beforeSend: function(jqXHR, settings) {
    jqXHR.url = settings.url;
    jqXHR.data = settings.data;
  }
});
const history = useQueries(useBasename(createHistory))({
  basename: "/app"
});
const ElmRoute = PineRoute;
window.$hubtranHistory = history;
function requireAuth(nextState, replaceState) {
  var _a, _b, _c;
  let path;
  let oldLogin = false;
  if (nextState.location.pathname === "/" && nextState.location.hash.length > 1) {
    path = nextState.location.hash + nextState.location.search;
    if (path.substr(0, 7) === "#/login") {
      oldLogin = true;
    }
  } else {
    path = nextState.location.pathname + nextState.location.search;
  }
  path = path.replace(/^\/?#/, "");
  if (!Auth.isAuthenticated() && (path.substr(0, 6) !== "/login" || oldLogin)) {
    const next = oldLogin ? null : path;
    replaceState({ nextPathname: next }, "/login");
    return;
  }
  if (isLogout(path)) {
    notifyPresenceServiceOfNavigation(path, nextState);
    return;
  }
  if (needsTermsAgreement(path) && path.substr(0, 6) !== "/terms") {
    replaceState({ nextPathname: path }, "/terms");
    return;
  }
  if (path === "/terms") {
    notifyPresenceServiceOfNavigation(path, nextState);
    return;
  }
  if (customerRepOnly()) {
    replaceState({ nextPathname: path }, "/customer_representative");
    return;
  }
  if (insightsOnly()) {
    replaceState({ nextPathname: path }, "/insights_dashboard");
    return;
  }
  if (readOnlyFactorInvoices()) {
    const readOnlyRedirectPath = readOnlyRedirect(path);
    if (readOnlyRedirectPath) {
      replaceState({ nextPathname: path }, readOnlyRedirectPath);
    }
    return;
  }
  if (Account.useFactorInvoiceWorkflowPage() && !((_a = nextState.location.query) == null ? void 0 : _a.forceReact)) {
    const match = path.match(/\/factor_invoices\/(\d+)/);
    if (match) {
      const target = factorInvoiceWorkflowWithEmail(
        Number(match[1]),
        (_b = nextState.location.query) == null ? void 0 : _b.emailId,
        (_c = nextState.location.query) == null ? void 0 : _c.onDone
      );
      replaceState(null, target.toString());
      return;
    }
  }
  notifyPresenceServiceOfNavigation(path, nextState);
}
function readOnlyFactorInvoices() {
  const user = Auth._currentUser;
  return !!(user == null ? void 0 : user.read_only_factor_invoices);
}
function notifyPresenceServiceOfNavigation(path, nextState) {
  const searchParams = new URLSearchParams(nextState.location.search);
  searchParams.delete("onDone");
  const searchString = searchParams.toString();
  const pathName = nextState.location.pathname;
  presenceService.startIfNeeded(Auth._currentUser);
  presenceService.userMovedTo(
    "/app" + maybeShortenedPath(pathName) + (searchString ? "?" + searchString : "")
  );
}
function maybeShortenedPath(pathName) {
  const urlRegex = /^(\/index-document-batches\/\d+)\/factor_invoices\/\d+/i;
  const match = pathName.match(urlRegex);
  if (match) {
    return match[1];
  } else {
    return pathName;
  }
}
function needsTermsAgreement(path) {
  return !Auth._currentUser.terms_agreed_to_at;
}
function isLogout(path) {
  return path.substr(0, 7) === "/logout";
}
function customerRepOnly() {
  return Auth._currentUser && Auth._currentUser.accessible_apps.includes("customer_representative") && !Auth._currentUser.accessible_apps.includes("payables") && !Auth._currentUser.accessible_apps.includes("receivables");
}
function insightsOnly() {
  return Auth._currentUser && Auth._currentUser.accessible_apps.includes("insights_dashboard") && !Auth._currentUser.accessible_apps.includes("payables") && !Auth._currentUser.accessible_apps.includes("receivables");
}
const store = configureStore();
class NewRoot extends React.Component {
  render() {
    if (window.location.pathname == "/users/password/edit") {
      return /* @__PURE__ */ React.createElement(ResetPasswordPage, null);
    } else {
      const user = Auth.getCurrentUser();
      const settingsPath = user && user.account.forwarder_account ? "/settings/contacts" : "/settings/account";
      return /* @__PURE__ */ React.createElement(Provider, { store, "data-component": "NewRoot" }, /* @__PURE__ */ React.createElement(Router, { history }, /* @__PURE__ */ React.createElement(Route, { path: "/", component: App }, /* @__PURE__ */ React.createElement(IndexRoute, { component: RootPage, onEnter: requireAuth }), /* @__PURE__ */ React.createElement(Route, { path: "okta_login", component: ElmRoute }), /* @__PURE__ */ React.createElement(Route, { path: "help", component: ElmRoute, onEnter: requireAuth }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "activity",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "billing_requirements",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "documents_viewer",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "email_search",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "elm*", component: ElmRoute, onEnter: requireAuth }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "dashboard*",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "to_be_scraped_loads",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "index-document-batches/:batchId",
          component: DocumentIndexerPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "flow",
          component: FlowModeFindNextItemPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "carrier_invoices_workflow/:carrierInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "factor_invoices_workflow/:factorInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "factor_invoices_workflow/batch/:batchId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "factor_invoices/:factorInvoiceId",
          component: FactorInvoiceExtractDataPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "readonly_factor_invoices/:factorInvoiceId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "readonly_document_batches/:documentBatchId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "readonly_emails/:emailId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "index-document-batches/:batchId/factor_invoices/:factorInvoiceId",
          component: FactorInvoiceExtractDataPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "login", component: LoginForm }), /* @__PURE__ */ React.createElement(Route, { path: "forwarding-has-moved", component: ElmRoute }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "document_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "document_batch_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "document_group_reviews/:reviewType/:reviewId",
          component: ElmRoute
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "logout", component: Logout, onEnter: requireAuth }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "index-document-batches/:batchId/loads/:loadId/carrier_invoices/:carrierInvoiceId",
          component: ConfirmAndSubmitPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "loads/:loadId(/carrier_invoices/:carrierInvoiceId)",
          component: ConfirmAndSubmitPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(Redirect, { from: "settings", to: settingsPath }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/carriers",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/carriers/:carrierId",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/carriers/:id/documents",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/account",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/client_portal",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/contacts",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/customers(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/debtors(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/document_types",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/exceptions",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/integrations",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/next_gen_audit",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/rules",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/reference_fields",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/reports",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/users(/:id)",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/users/:id/enable",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/verifications",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/scraper_status",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "settings/pod_definition",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "forwarding/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "client_submission/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "verification_batch/*",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "index-document-batches/:documentBatchId/loads/:loadStateId/confirm",
          components: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "email/:id",
          component: EmailPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "email_merge",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "reply/:id",
          component: ReplyView,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(Route, { path: "terms", component: ElmRoute, onEnter: requireAuth }), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "customer_representative",
          component: () => {
            window.location.href = "/customer_representative";
            return null;
          }
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "insights_dashboard",
          component: () => {
            window.location.href = "/insights_dashboard";
            return null;
          }
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "loads/:loadId/carrier_invoices/:carrierInvoiceId/ltl-reconcile",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "held_submissions",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "my_clients_demo",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "noa_management",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "noa_management/sent",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "noa_management/skipped",
          component: ElmRoute,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(
        Route,
        {
          path: "analytics",
          component: AnalyticsPage,
          onEnter: requireAuth
        }
      ), /* @__PURE__ */ React.createElement(Redirect, { from: "*", to: "/" }))));
    }
  }
}
const AP = {
  bootstrap: function() {
    Hotkeys.listenForKeys(
      {
        zoomIn: ["numplus", "alt+="],
        zoomOut: ["numminus", "alt+-"],
        rotateLeft: ["left"],
        rotateRight: ["right"],
        nextPage: ["alt+p", "pagedown"],
        prevPage: ["alt+shift+p", "pageup"],
        nextGroup: "alt+g",
        prevGroup: "alt+shift+g",
        togglePOD: ["alt+d", "numpad0", "alt+shift+d"],
        markIllegible: ["alt+t"],
        toggleHidden: ["alt+h"],
        changeDoctype: ["numstar", "alt+e"],
        hotkeyMenu: ["ctrl+/"]
      },
      this
    );
    if (window.location.pathname == "/passwords/expired_token" || window.location.pathname.startsWith("/driver_app/links/"))
      return;
    ReactDOM.render(
      React.createElement(NewRoot),
      document.getElementById("react-container")
    );
  }
};
window.AccountsPayable = AP;
$(document).ready(function() {
  AP.bootstrap();
});
export default AP;
